import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ListItem } from '../../../../models/api/core/list/list-item';
import { FilterCriteria } from '../../../../models/api/reports/filter-detail-response';
import { BaseComponent } from '../../../base/base.component';
import { SelectFieldComponent } from '../../../core/fields/select-field.component';
import { FilterSection, ICriteria } from '../edit-filter.component';

@Component({
  selector: 'app-status-criteria',
  imports: [CommonModule, SelectFieldComponent],
  template: `
    <div class="tw-pt-2">
      <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full">
        <app-select-field
          label="Claim status"
          labelClasses="tw-basis-full md:tw-basis-[30%] tw-whitespace-nowrap"
          valueClasses="tw-basis-full md:tw-basis-[70%] tw-min-w-0 tw-overflow-hidden"
          [control]="fg.controls.claimStatus"
          optionLabel="description"
          optionValue="value"
          [multiple]="true"
          [multipleFilter]="false"
          [virtualScroll]="false"
          [chip]="true"
          [options]="statuses"
          [showHelpText]="false"
          placeholder=""
          [showHeader]="true"
          selectAllLabel="All"
        />
      </div>
    </div>
  `,
  styles: ``,
})
export class StatusCriteriaComponent
  extends BaseComponent
  implements OnInit, ICriteria
{
  statuses: ListItem[] = [
    { value: 'o', description: 'Open' },
    { value: 'c', description: 'Closed' },
    { value: 'i', description: 'Incident' },
  ];

  @Input({ required: true })
  section: FilterSection;

  fg = new FormGroup({
    claimStatus: new FormControl<string[]>(['o', 'c', 'i']),
  });

  setStatusesFromCriteria(criteria: FilterCriteria[]) {
    const foundStatuses = this.statuses
      .filter((status) =>
        criteria.some((c) => c.values.includes(status.value.toUpperCase())),
      )
      .map((status) => status.value);

    this.fg.controls.claimStatus.setValue(foundStatuses);
  }

  ngOnInit() {
    this.section.criteria = this;

    if (this.section.values?.length) {
      this.setStatusesFromCriteria(this.section.values);
    }

    this.dispose.subs = this.fg.controls.claimStatus.valueChanges.subscribe(
      (values) => {
        const count = values?.length || 0;
        this.emitCount(count);
      },
    );
  }

  private emitCount(count?: number) {
    const isAll = count === 0 || count === this.statuses.length;
    const statusCount = isAll ? 0 : count;
    this.section.count.set(statusCount);
  }

  valid(): boolean {
    return true;
  }

  getCriteria(): FilterCriteria[] {
    const values = this.fg.controls.claimStatus.value || [];
    if (values.length === 0 || values.length === this.statuses.length) {
      return [];
    }

    return values.map((status) => ({
      tableAlias: 'claim_status_as_of',
      column: 'CLAIM_STATUS_CODE',
      displayName: '',
      operator: 'EQUALS',
      values: [status],
      lineOfBusiness: '',
      dataType: 'VARCHAR2',
      isClaimLab: false,
      formattedOperator: '',
      formattedValue: '',
      filterSection: 'Status',
      filterSubsection: '',
    }));
  }
}
